// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2U0Eo","content":"Consent_content__2gKl2","footer":"Consent_footer__3snS9"};